import { ReadingRoomCardNotificationEntryItem, ReadingRoomCardScheduleEntryItem } from 'types/reading-room.interface';

export function sortSchedule(schedule: ReadingRoomCardScheduleEntryItem[]): ReadingRoomCardScheduleEntryItem[] {
  const dayMap: { [key: string]: number } = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7
  };

  schedule.sort(
    (a: ReadingRoomCardScheduleEntryItem, b: ReadingRoomCardScheduleEntryItem) =>
      (dayMap[a.day ?? 'Monday'] ?? 0) - (dayMap[b.day ?? 'Monday'] ?? 0)
  );
  return schedule;
}

export function isNotificationVisible(notification: ReadingRoomCardNotificationEntryItem): boolean {
  const currentDate = new Date(new Date().setUTCHours(0, 0, 0, 0));

  if (notification.startDate && notification.endDate) {
    const startDate = new Date(notification.startDate);
    const endDate = new Date(notification.endDate);

    return startDate <= currentDate && currentDate <= endDate;
  } else if (notification.startDate) {
    const startDate = new Date(notification.startDate);
    return startDate <= currentDate;
  }

  return false;
}
